import { Link } from 'react-router-dom';
import { articles } from '@/mocks/movies';

export default function NewsSection() {
  const featuredArticle = articles[0];
  const otherArticles = articles.slice(1, 5);

  return (
    <section className="w-full px-4 md:px-6 py-14 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
              影视资讯
            </h2>
            <p className="text-sm md:text-base text-foreground-500">
              最新影视动态与深度影评
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
          <Link
            to={`/article/${featuredArticle.slug}`}
            className="lg:col-span-1 group cursor-pointer"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          >
            <div className="bg-background-50 rounded-xl overflow-hidden">
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={featuredArticle.cover}
                  alt={featuredArticle.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-primary-500 text-background-50 text-xs rounded-md font-medium">
                    {featuredArticle.category}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-base font-heading font-bold text-foreground-900 group-hover:text-primary-600 transition-colors duration-200 line-clamp-2 mb-2">
                  {featuredArticle.title}
                </h3>
                <p className="text-sm text-foreground-500 line-clamp-2 mb-4 leading-relaxed">
                  {featuredArticle.summary}
                </p>
                <div className="flex items-center gap-3 text-xs text-foreground-400">
                  <span>{featuredArticle.author}</span>
                  <span>{featuredArticle.date}</span>
                  <span>{featuredArticle.readCount.toLocaleString()} 阅读</span>
                </div>
              </div>
            </div>
          </Link>

          <div className="lg:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-5">
            {otherArticles.map((article) => (
              <Link
                key={article.id}
                to={`/article/${article.slug}`}
                className="group cursor-pointer bg-background-50 rounded-xl overflow-hidden"
                onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              >
                <div className="relative aspect-[16/10] overflow-hidden">
                  <img
                    src={article.cover}
                    alt={article.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-2.5 py-1 bg-secondary-500 text-background-50 text-xs rounded-md font-medium">
                      {article.category}
                    </span>
                  </div>
                </div>
                <div className="p-4">
                  <h3 className="text-sm font-heading font-bold text-foreground-900 group-hover:text-primary-600 transition-colors duration-200 line-clamp-2 mb-2">
                    {article.title}
                  </h3>
                  <div className="flex items-center gap-3 text-xs text-foreground-400">
                    <span>{article.author}</span>
                    <span>{article.date}</span>
                    <span>{article.readCount.toLocaleString()} 阅读</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}